import { render, staticRenderFns } from "./LanguageConfiguration.vue?vue&type=template&id=735fd45d&scoped=true&"
import script from "./LanguageConfiguration.vue?vue&type=script&lang=ts&"
export * from "./LanguageConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735fd45d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDivider,VForm,VImg,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('735fd45d')) {
      api.createRecord('735fd45d', component.options)
    } else {
      api.reload('735fd45d', component.options)
    }
    module.hot.accept("./LanguageConfiguration.vue?vue&type=template&id=735fd45d&scoped=true&", function () {
      api.rerender('735fd45d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/policies/LanguageConfiguration.vue"
export default component.exports